interface Uni {
	navigateTo: (options?: { url: string }) => void;
	navigateBack: (options?: { delta?: number }) => void;
	switchTab: (options?: { url: string }) => void;
	reLaunch: (options?: { url: string }) => void;
	redirectTo: (options?: { url: string }) => void;
	getEnv: (callback: (env: { nvue?: boolean; plus?: boolean; h5?: boolean }) => void) => void;
	postMessage: (options?: { data: any }) => void;
}

const uni: Uni = (function () {
	'use strict';
	try {
		const e = {};
		Object.defineProperty(e, 'passive', {
			get() {
				return true;
			},
		});
		window.addEventListener('test-passive', () => {}, e);
	} catch {}

	const n = Object.prototype.hasOwnProperty;
	function i(e: any, i: any) {
		return n.call(e, i);
	}

	const t: any[] = [];

	function r() {
		return (window as any).__dcloud_weex_postMessage || (window as any).__dcloud_weex_;
	}

	const o = function (e: any, n: any) {
		const i = { options: { timestamp: +new Date() }, name: e, arg: n };
		if (r()) {
			if ('postMessage' === e) {
				const o = { data: [n] };
				return (window as any).__dcloud_weex_postMessage
					? (window as any).__dcloud_weex_postMessage(o)
					: (window as any).__dcloud_weex_.postMessage(JSON.stringify(o));
			}
			const a = { type: 'WEB_INVOKE_APPSERVICE', args: { data: i, webviewIds: t } };
			(window as any).__dcloud_weex_postMessage
				? (window as any).__dcloud_weex_postMessageToService(a)
				: (window as any).__dcloud_weex_.postMessageToService(JSON.stringify(a));
		}
		if (!(window as any).plus)
			return (window as any).parent.postMessage(
				{ type: 'WEB_INVOKE_APPSERVICE', data: i, pageId: '' },
				'*',
			);
		if (0 === t.length) {
			const d = plus.webview.currentWebview();
			if (!d) throw new Error('plus.webview.currentWebview() is undefined');
			const s = d.parent();
			let w = '';
			((w = s ? s.id : d.id), t.push(w));
		}
		if (plus.webview.getWebviewById('__uniapp__service'))
			(plus.webview as any).postMessageToUniNView(
				{ type: 'WEB_INVOKE_APPSERVICE', args: { data: i, webviewIds: t } },
				'__uniapp__service',
			);
		else {
			const u = JSON.stringify(i);
			plus.webview
				.getLaunchWebview()
				.evalJS(
					'UniPlusBridge.subscribeHandler("'
						.concat('WEB_INVOKE_APPSERVICE', '",')
						.concat(u, ',')
						.concat(JSON.stringify(t), ');'),
				);
		}
	};

	const a: any = {
		navigateTo() {
			const e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
			const n = e.url;
			o('navigateTo', { url: encodeURI(n) });
		},
		navigateBack() {
			const e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
			const n = e.delta;
			o('navigateBack', { delta: parseInt(n) || 1 });
		},
		switchTab() {
			const e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
			const n = e.url;
			o('switchTab', { url: encodeURI(n) });
		},
		reLaunch() {
			const e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
			const n = e.url;
			o('reLaunch', { url: encodeURI(n) });
		},
		redirectTo() {
			const e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
			const n = e.url;
			o('redirectTo', { url: encodeURI(n) });
		},
		getEnv(callback: any) {
			r()
				? callback({ nvue: true })
				: (window as any).plus
					? callback({ plus: true })
					: callback({ h5: true });
		},
		postMessage() {
			const e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
			o('postMessage', e.data || {});
		},
	};

	const d = /uni-app/i.test(navigator.userAgent);
	const s = /Html5Plus/i.test(navigator.userAgent);
	const uni: any = {};
	for (const key in a) {
		if (i(a, key)) {
			uni[key] = a[key];
		}
	}

	if (!uni.getEnv) {
		uni.getEnv = function (callback: any) {
			if (r()) {
				callback({ nvue: true });
			} else if ((window as any).plus) {
				callback({ plus: true });
			} else {
				callback({ h5: true });
			}
		};
	}

	return uni;
})();

export default uni;
